import{useRef as u,useMemo as c}from"react";function o(r){const n=u(r);n.current=c(()=>r,[r]);const t=u();return t.current||(t.current=function(...e){return n.current.apply(this,e)}),t.current}export{o as u};
